"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.configForLayer = void 0;

var _airquality = _interopRequireDefault(require("./layers/airquality"));

var _convectiveoutlook = _interopRequireDefault(require("./layers/convectiveoutlook"));

var _droughtmonitor = _interopRequireDefault(require("./layers/droughtmonitor"));

var _earthquakes = _interopRequireDefault(require("./layers/earthquakes"));

var _fires = _interopRequireDefault(require("./layers/fires"));

var _fireOutlook = _interopRequireDefault(require("./layers/fireOutlook"));

var _lightningStrikes = _interopRequireDefault(require("./layers/lightningStrikes"));

var _records = _interopRequireDefault(require("./layers/records"));

var _rivers = _interopRequireDefault(require("./layers/rivers"));

var _stormcells = _interopRequireDefault(require("./layers/stormcells"));

var _stormreports = _interopRequireDefault(require("./layers/stormreports"));

var _text = _interopRequireDefault(require("./layers/text"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MAPPING = {
  'air-quality': _airquality.default,
  'convective': _convectiveoutlook.default,
  'drought-monitor': _droughtmonitor.default,
  earthquakes: _earthquakes.default,
  fires: _fires.default,
  'fire-outlook': _fireOutlook.default,
  'lightning-strikes': _lightningStrikes.default,
  records: _records.default,
  'river-observations': _rivers.default,
  stormcells: _stormcells.default,
  stormreports: _stormreports.default,
  text: _text.default
};

var configForLayer = function (layer) {
  return MAPPING[layer];
};

exports.configForLayer = configForLayer;
var _default = {
  airquality: _airquality.default,
  convectiveOutlook: _convectiveoutlook.default,
  droughtMonitor: _droughtmonitor.default,
  earthquakes: _earthquakes.default,
  fires: _fires.default,
  fireOutlook: _fireOutlook.default,
  lightningStrikes: _lightningStrikes.default,
  records: _records.default,
  rivers: _rivers.default,
  stormcells: _stormcells.default,
  stormreports: _stormreports.default,
  text: _text.default
};
exports.default = _default;